import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";

const DRUPAL_HOST = "kx-make.cfaes.ohio-state.edu";

/**
 * If content was exported without MEDIA_CDN_BASE rewrite, rewrite absolute
 * Drupal media URLs in JSON responses to contentMediaOrigin.
 * No-op when environment.contentMediaOrigin is unset.
 */
@Injectable()
export class ContentMediaUrlInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const mediaOrigin = environment.contentMediaOrigin?.replace(/\/$/, "");
    if (!mediaOrigin) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      map((event) => {
        if (!(event instanceof HttpResponse) || event.body == null) {
          return event;
        }
        return event.clone({ body: rewriteDeep(event.body, mediaOrigin) });
      })
    );
  }
}

function rewriteDeep(value: unknown, mediaOrigin: string): unknown {
  if (typeof value === "string") {
    return value.replace(
      new RegExp(`https?://${DRUPAL_HOST.replace(/\./g, "\\.")}`, "gi"),
      mediaOrigin
    );
  }
  if (Array.isArray(value)) {
    return value.map((v) => rewriteDeep(v, mediaOrigin));
  }
  if (value && typeof value === "object") {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      out[k] = rewriteDeep(v, mediaOrigin);
    }
    return out;
  }
  return value;
}
